module.exports = __webpack_public_path__ + "img/logo.2cb19f4e.png";